/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import React, { Component } from 'react';
import { Checkbox as SemanticCheckbox } from 'semantic-ui-react';

class Checkbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: !!props.value,
        };
    }

    onChange = (e, { checked, name }) => {
        if (this.props.onChange) {
            this.setState({ value: checked });
            this.props.onChange(e, { name, value: checked });
        }
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value) {
            this.setState({ value: nextProps.value });
        }
    }

    render() {
        const { value } = this.state;

        return (
            <React.Fragment>
                <SemanticCheckbox className="nunchee" {...this.props} onChange={this.onChange} checked={value} />
                <style>
                    {`
            .ui.toggle.checkbox.nunchee input:checked~label:before,
            .ui.toggle.checkbox.nunchee input:checked~.box:before,
            .ui.toggle.checkbox.nunchee input:checked~label:before {
                background-color: #0c3454!important;
            }
          `}
                </style>
            </React.Fragment>
        );
    }
}

export default Checkbox;
